import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'main-header-search-form',
    template: ``,
    standalone: false
})
export class MainHeaderSearchFormComponentGeneric implements OnInit {

    constructor() {}

    ngOnInit() {}

}
